var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4734 9.3001H13.301V7.5001C13.301 6.57131 13.3766 5.98631 14.7077 5.98631H16.3888V3.12432C15.5708 3.03972 14.7482 2.99832 13.9247 3.00012C11.483 3.00012 9.70097 4.49141 9.70097 7.2292V9.3001H7.00098V12.9001L9.70097 12.8992V21.0001H13.301V12.8974L16.0603 12.8965L16.4734 9.3001Z",
    fill: "#63666A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.7d729fc604c79cb2b7eed23364fa50a9.svg";
export { ForwardRef as ReactComponent };